import {FC, Card, PropsWithChildren, useMemo} from 'external/react'
import Icon from 'external/fortawesome'

import ButtonBack from 'components/ButtonBack'
import BasicLayout from './BasicLayout'
import useAdmin from 'context/admin-context/hook'

const ClientsContainer: FC<PropsWithChildren> = props => {
    const {children} = props
    const { roleName } = useAdmin();
    const backPath = useMemo(() => `/${roleName?.substring(0, roleName.indexOf('_') >= 0 ? roleName.indexOf('_') : roleName.length) || 'admin'}`, [roleName])
    return (
        <BasicLayout>
            <Card.Header className='card--header d-flex'>
                <div className='d-flex flex-column justify-content-center'>
                    <ButtonBack path={backPath}  />
                </div>
                <div className='ms-2' style={{ fontSize: '31px' }}>
                    <Icon name='faUsers' /> Clientes
                </div>
            </Card.Header> 
            {children}
        </BasicLayout>
    )
}

export {ClientsContainer as default}